import { JobStore } from '@y42/job';
import { DatasourceTableJobState } from './datasource-table-job.model';

export abstract class DatasourceTableJobStore extends JobStore<DatasourceTableJobState> {
  constructor() {
    super();
  }
}
